import React from 'react'
import { useDispatch } from 'react-redux'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import { Formik } from 'formik'
import {
  CssBaseline,
  Checkbox,
  FormControlLabel,
  Box,
  Button,
  Container,
  Link,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import Page from 'src/components/Page'
import { useTranslation } from 'react-i18next'
import { orange } from '@material-ui/core/colors'
import { NoEncryption } from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'
import { login } from '../../app/slices/userSlice'
import './Login.css'

const GreenCheckbox = withStyles({
  root: {
    color: orange[400],
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />)

const useStyles = makeStyles((theme) => ({
  root: {
  },
  image: {
    backgroundImage: 'url(/images/login.png)',
    backgroundSize: '100% 100vh',
    backgroundRepeat: 'no-repeat',

    backgroundPosition: 'center 25%',
  },
  logo: {
    backgroundImage: 'url(/images/logo.png)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundPosition: 'center 0',
    position: 'relative',
    left: '200px',
    top: '0',
    objectFit: 'cover',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  warning: {
    backgroundColor: '#f9b233',
    color: '#fff',
    padding: '14px',
    borderRadius: '10px',
  },
  forgetPasswordSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  easyLogin: {
    padding: '0',
    border: NoEncryption,
    borderTop: 'medium double #333',
    color: '#333',
    textAlign: 'center',
    '&:after': {
      content: 'ورود راحت با',
      display: 'inlie-block',
      top: '-0.7em',
      fontSize: '1.5em',
      padding: '0 0.25em',
      background: 'white',
    },
  },
  formLogin: {
    width: '100%',
    margin: '0 auto',
    '@media (max-width: 960px)': {
      width: '100%',
    },
  },
  customInput: {
    display: 'block',
    width: '100%',
  },
  socialLoginButton: {
    boxShadow: 'none',
    borderRadius: '10px',
    width: '35%',
    height: '55px',
    padding: '20px 45.1px 20px 45px',
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #b5c3d6',
    textTransform: 'capitalize',
    fontWeight: '600',
    fontSize: '18px',
    display: 'flex',
    alignSelf: 'flex-start',
    position: 'reactive',
    '@media (max-width: 960px)': {
      width: '45%',
    },
  },
  loginContainer: {
    width: '75%',
    '@media (max-width: 960px)': {
      width: '100%',
    },
    '@media (min-width: 1200px)': {
      width: '60%',
    },
  },
}))

const LoginView = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const classes = useStyles()
  const { t } = useTranslation()
  const [remember, setRemember] = React.useState(false)

  return (
    <Page
      className={classes.root}
      title="ورود پنل استعدادیابی آنلاین"
      metaName="گارنت"
      metaContent="ورود گارنت | پلتفرم استعدادیابی آنلاین"
      linkRef="canonical"
      linkHref="https://panel.garnettalent.ir/login"
    >
      <Box
        className="main-login"
      >
        <CssBaseline />

        <Box
          className="login-image-warp"
          style={{ height: '100%' }}
        >
          <img
            style={{ height: '100%' }}
            src="images/login.jpg"
            className="new-login-image"
            alt="Login"
          />

        </Box>

        <Box className="new_login_form_section">
          <Box className="new_login_form_section_box">
            <img src="images/logo.svg" alt="logo" className="login_logo" />

            <Container className={classes.loginContainer}>
              <Formik
                initialValues={{
                  username: '',
                  password: '',
                }}
                validationSchema={Yup.object().shape({
                  username: Yup.string().max(255).required('نام کاربری ضروری است'),
                  password: Yup.string().max(255).required('رمز عبور ضروری است'),
                  // remember: Yup.boolean().oneOf([true, false]),
                })}
                onSubmit={(values) => {
                  dispatch(login({
                    userName: values.username,
                    password: values.password,
                  }, navigate, remember))
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  touched,
                  values,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <label htmlFor="username">نام کاربری(کد ملی)*</label>
                    <TextField
                      id="username"
                      error={Boolean(touched.username && errors.username)}
                      fullWidth
                      helperText={touched.username && errors.username}
                      // placeholder="name@email.com"
                      margin="normal"
                      name="username"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="text"
                      value={values.username}
                      variant="outlined"
                      style={{ marginTop: '5px' }}
                      className={classes.customInput}
                      InputProps={{
                        id: 'username',
                      }}

                    />

                    {/* <br /> */}
                    <br />
                    <label htmlFor="password">رمز عبور*</label>
                    <TextField
                      error={Boolean(touched.password && errors.password)}
                      fullWidth
                      helperText={touched.password && errors.password}
                      placeholder="*******"
                      margin="normal"
                      name="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="password"
                      value={values.password}
                      variant="outlined"
                      style={{ marginTop: '5px' }}
                      className={classes.customInput}
                      inputProps={{ 'aria-label': 'description', id: 'password' }}
                    />
                    <div className={classes.forgetPasswordSection}>
                      <FormControlLabel
                        // value={values.remember}
                        value={remember}
                        control={(
                          <GreenCheckbox
                            color="primary"
                            onBlur={handleBlur}
                            // onChange={handleChange}
                            onChange={(e) => setRemember(e?.target?.checked)}
                          />
                      )}
                        label="مرا به خاطر بسپار"
                        labelPlacement="end"
                        style={{ color: '#000' }}
                      />
                      <Typography
                        color="textSecondary"
                        variant="body1"
                      >
                        <Link
                          component={RouterLink}
                          to="/resetpassword"
                          variant="h6"
                          style={{ color: '#f9b233', fontSize: '16px' }}
                        >
                          {t('i_forget_password')}
                        </Link>
                      </Typography>
                    </div>
                    <Box my={2}>
                      <Button
                        className={classes.warning}
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                      >
                        وارد شوید
                      </Button>
                    </Box>

                  </form>
                )}
              </Formik>
            </Container>
            <Typography
              color="textSecondary"
              variant="body1"
              style={{ margin: '70px auto 50px auto' }}
            >
              حساب کاربری نداری؟
              {' '}
              <Link
                component={RouterLink}
                to="/register"
                variant="h6"
                style={{ color: '#f9b233', fontSize: '18px' }}
              >
                ثبت نام کنید
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Page>
  )
}

export default LoginView
